<template>
    <SupplierDetailTable :table-settings="tableSettings" :debounce="debounce" :sort-options="sortOptions" ref="data_table"
        :link="getTenderRoute"
        @row-clicked="(item) => {
            $router.push(getTenderRoute(item));
        }
            ">
        <template v-slot:data_risk="row">
            <RiskLevelDumpling :value="row.item.risk" :level="versionRiskLevel(row.item, analysisVersion)" />
        </template>

        <template v-slot:data_flags="row">
            <FlagDetailRowToggler :row="row" :callback="loadRowDetail" />
        </template>

        <template v-slot:data_price="row">
            {{ formatNumber(row.item.price) }}
        </template>

        <template v-slot:data_title="row">
            {{ row.item.title }}
            <div v-if="row.item.award_url_profile || row.item.award_url_vestnik">
                <a v-if="row.item.award_url_vestnik" :href="row.item.award_url_vestnik" target="_blank" @click.stop>{{
                    $t("vestnik_url") }}<b-icon icon="box-arrow-up-right" font-scale="0.6"
                        style="margin-bottom: 5px;" /></a>
                <span v-if="row.item.award_url_profile && row.item.award_url_vestnik">, </span>
                <a v-if="row.item.award_url_profile" :href="row.item.award_url_profile" target="_blank" @click.stop>{{ $t("profile_url")
                }}<b-icon icon="box-arrow-up-right" font-scale="0.6" style="margin-bottom: 5px;" /></a>
            </div>
        </template>

        <template v-slot:data_signature_date="row">
            <template v-if="row.item.estimated_signature_date">{{ $filters.formatDate(row.item.signature_date, "YYYY") }}</template>
            <template v-else>{{ $filters.formatDate(row.item.signature_date, "D. M. YYYY") }}</template>
        </template>

        <template v-slot:row_details="row">
            <FlagDetailRow :row="row" :version="analysisVersion" />
        </template>
    </SupplierDetailTable>
</template>

<script>
import SupplierDetailTable from "@/components/SupplierDetailTable.vue";
import RiskLevelDumpling from "@/components/RiskLevelDumpling.vue";
import formattersMixin from "@/plugins/formattersMixin.js";
import riskMixin from "@/plugins/riskMixin.js";
import FlagDetailRow from "@/components/FlagDetailRow.vue";
import FlagDetailRowToggler from "@/components/FlagDetailRowToggler.vue";

export default {
    props: {
        tableSettings: { type: Object, required: true },
        sortOptions: { type: Array, required: false, default: () => [] },
        analysisVersion: { type: String, required: true },
        analysisHash: { type: String, required: true },
        supplierId: { type: [Number, String], required: true },
        debounce: { type: Number, required: false, default: 700 }
    },
    mixins: [formattersMixin, riskMixin],
    components: { SupplierDetailTable, RiskLevelDumpling, FlagDetailRow, FlagDetailRowToggler },
    data: function () {
        return {};
    },
    methods: {
        loadRowDetail: function (row) {
            row.item.toggleDetails();

            this.onShowRowDetail(row);
        },
        onShowRowDetail: function (row) {
            // first displaying of details starts ajax
            if (row.item.flags === undefined) {
                this.loadTenderFlags(row.item.id)
                    .then((flags) => (row.item.flags = flags))
                    .catch((e) => {
                        console.log(e);
                        row.item.flags = [];
                    })
                    .finally(() => {
                        // little hack - details slot template doesn't react on data changes,
                        // double toggle refreshes data
                        row.item.toggleDetails(); // hide
                        row.item.toggleDetails(); // show again
                    });
            }
        },
        loadTenderFlags: function (tenderId) {
            return new Promise((resolve, reject) => {
                var params = {
                    format: "json",
                    supplier: this.supplierId,
                    tender: tenderId
                };

                params[`${this.analysisVersion}_hash`] = this.analysisHash;

                this.$store.getters.api
                    .get("flag/", { params: params })
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((e) => {
                        reject(e);
                    });
            });
        },
        refresh: function () {
            this.$refs.data_table.refresh();
        },
        setTotalRows: function (count) {
            this.$refs.data_table.setTotalRows(count);
        },
        getTenderRoute: function (item) {
            return {
                name: 'tender-detail',
                params: {
                    version: this.analysisVersion,
                    hash: this.analysisHash,
                    slug: item.slug
                }
            }
        }
    }
};
</script>
